import { createFileRoute } from "@tanstack/react-router";

// Debug route used by E2E tests to verify error boundaries / SSR error page.
//   /debug/throw?when=ssr     → throws inside the loader (server during SSR,
//                                client during subsequent navigation)
//   /debug/throw?when=render  → throws inside the React component
//   /debug/throw              → renders OK ("debug-throw-ok")

type Search = { when?: "ssr" | "render" };

export const Route = createFileRoute("/debug/throw")({
  validateSearch: (search: Record<string, unknown>): Search => ({
    when: search.when === "ssr" || search.when === "render" ? search.when : undefined,
  }),
  loaderDeps: ({ search }) => ({ when: search.when }),
  loader: ({ deps }) => {
    if (deps.when === "ssr") {
      throw new Error("E2E_SSR_THROW");
    }
    return null;
  },
  component: DebugThrow,
});

function DebugThrow() {
  const { when } = Route.useSearch();
  if (when === "render") {
    throw new Error("E2E_RENDER_THROW");
  }
  return (
    <div className="p-8" data-testid="debug-throw-ok">
      <h1>Debug throw page</h1>
      <p>Append ?when=ssr or ?when=render to trigger errors.</p>
    </div>
  );
}